import type { ObjectId } from '@freightview/object-id'

import type { HintedString } from '../core/hinted-string.ts'
import {
  vArray,
  vMaxValue,
  vObject,
  vOpt,
  type vOutput,
  vPicklist,
  vPipe,
  vString,
  vStringToNumber,
} from '../validation/index.ts'

export type KbUserInfo = {
  name: string
  email: string
}
export type KbItemStatus = 'draft' | 'published'
export type KbItemRevisionEntry = {
  _id: ObjectId
  uri: string
  createdAt: Date
  userInfo: KbUserInfo
}
export const kbItemTags = ['shipper', 'blog', 'admin'] as const
export type KbItemTag = HintedString<(typeof kbItemTags)[number]>
export type KbItemDraft = {
  content: string
  title?: string
  updatedAt: Date
  userInfo: KbUserInfo
}
export interface KnowledgeContent {
  _id: ObjectId
  contentId?: string
  title: string
  content: string
  link?: string
  embedding?: number[]
  createdAt: Date
  updatedAt: Date
  lastUpdatedBy?: KbUserInfo
  draft?: KbItemDraft
  status?: KbItemStatus
  revisions?: KbItemRevisionEntry[]
  tags?: KbItemTag[]
}

export const kbSearchSchema = vObject({
  query: vString(),
  limit: vPipe(vOpt(vStringToNumber(), 25), vMaxValue(25)),
  skip: vOpt(vStringToNumber(), 0),
  tags: vOpt(vArray(vString())),
  status: vOpt(vPicklist(['draft', 'published'])),
})
export type KbSearchRequest = vOutput<typeof kbSearchSchema> & {
  continuationToken?: string
}

export type KbListItem = Pick<
  KnowledgeContent,
  '_id' | 'title' | 'link' | 'tags' | 'status' | 'updatedAt'
>
export type KbSearchResponse = KbListItem[]
